import { Form, Input, Button, Row, Col, Card } from 'antd';
import { MobileOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { userActions } from '../../redux/actions/userAction';
import handleRsponse from '../../helper/handleRsponse';
import customerRepo from '../../repository/customerRepo';
import Utility, { notifyType, notifyPlacement } from '../../helper/utility';


const SignIn = (props) => {
    let mobileInput = null;
    const [error, setError] = useState(false);
    const [isLoaded, setIsLoaded] = useState(true);

    //const [user, setUser] = useState([]);
    useEffect(() => {
        mobileInput.focus();
    }, [])
    const getSms = (mobile) => {
        handleRsponse.handleAxios(customerRepo.sendSms({ 'mobile': mobile }), afterGetSms, setIsLoaded)
    }

    const onFinish = (values) => {
        console.log('Success:', values);
        props.requestCode(values.mobile);
        getSms(values.mobile);

    };
    const afterGetSms = (response) => {
        if (response.status == 200) {
            setTimeout(() => {
                //alert(response.data.data);
                if (response.data.isSuccess)
                    props.history.push('/registerCode');
                else
                    Utility.openNotification(notifyType.error, notifyPlacement.bottomLeft, 'خطا', response.data.message);
            }, 100);
        }

    }

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (

        <Row style={{ marginTop: '10%' }}>
            <Col xs={{ span: 18, offset: 3 }} lg={{ span: 8, offset: 8 }}>
                <Card>
                    <Form
                        name="basic"
                        initialValues={{
                            mobile: props.currentMobile
                        }}
                        onFinish={onFinish.bind(this)}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <div style={{ textAlign: 'right', paddingBottom: '15px' }}>
                            <b>لطفا موبایل خود را وارد نمایید</b>
                        </div>

                        <Form.Item
                            name="mobile"
                            rules={[
                                {
                                    required: true,
                                    message: 'لطفا موبایل خود را وارد نمایید!',
                                },
                                {
                                    pattern: new RegExp("09[0-909][0-9]-?[0-9]{3}-?[0-9]{4}"),
                                    message: "شماره موبایل صحیح نمی باشد"
                                },
                            ]}
                        >
                            <Input placeholder="شماره موبایل"
                                prefix={<MobileOutlined />}
                                maxLength="11"
                                style={{borderRadius:'35px'}}
                                onPaste={(e) => { e.preventDefault(); return false; }}
                                ref={(text) => { mobileInput = text; }} />
                        </Form.Item>
                        <br />
                        <Form.Item
                          
                        >
                            <Button type="primary" danger shape="round" size='large' className='serviceType' block htmlType="submit" disabled={!isLoaded}>
                                دریافت کد تایید
                            </Button>
                        </Form.Item>
                    </Form>
                    {(!isLoaded) ? <span>منتظر بمانید...</span> : ''}

                </Card>
            </Col>
        </Row>

    );
}
const mapStateToProps = state => ({
    currentMobile: state.user.currentMobile,
});
const mapActionCreateor = {
    requestCode: userActions.requestCode,
}
export default connect(mapStateToProps, mapActionCreateor)(SignIn)
